import { cn } from '@/shared/utils';
import type { TextareaProps } from '@/view/shared/form/Textarea.props';
import { TextareaBase } from '@/view/shared/form/TextareaBase';

export function Textarea({
  label,
  errorMessage,
  description,
  placeholder,
  classNames,
  name,
  value,
  isValid,
  onChange,
  rows = 5,
}: Readonly<TextareaProps>) {
  const hasError = !isValid && Boolean(value);

  return (
    <div className={classNames?.container ?? ''}>
      {label && (
        <label htmlFor={name} className={cn('block text-sm font-medium mb-1', classNames?.label)}>
          {label}
        </label>
      )}
      <TextareaBase
        id={name}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        rows={rows}
        classNames={{
          textarea: cn(
            hasError && 'border-destructive focus:ring-destructive/30 focus:border-destructive',
            classNames?.textarea,
          ),
        }}
      />
      {description && !hasError && (
        <p className={cn('text-xs text-muted-foreground mt-1', classNames?.description)}>
          {description}
        </p>
      )}
      <output
        className={cn(
          'grid transition-[grid-template-rows] duration-200 ease-out',
          hasError && errorMessage ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <p className={cn('overflow-hidden text-body-xs text-destructive', classNames?.error)}>
          {errorMessage}
        </p>
      </output>
    </div>
  );
}
